import React from 'react';
import { Smartphone } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Devices', href: '#devices' },
    { name: 'App', href: '#app' },
    { name: 'Contact', href: '#contact' },
    { name: 'Research', href: '#ai-models' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-max py-12">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left Side - Logo and Mission */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/images/logo/logo-primary.png" 
                alt="Oralytics Logo" 
                className="h-8 w-auto"
              />
              <span className="text-2xl font-bold">Oralytics</span>
            </div>
            <p className="text-gray-300 max-w-md">
              AI for better oral health. Bringing professional dental analysis to your smartphone.
            </p>
          </div>

          {/* Right Side - Quick Links */}
          <div className="flex flex-col sm:flex-row justify-end space-y-4 sm:space-y-0 sm:space-x-8">
            <div>
              <h4 className="font-semibold mb-3">Quick Links</h4>
              <div className="space-y-2">
                {quickLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    className="block text-gray-300 hover:text-white transition-colors"
                  >
                    {link.name}
                  </a>
                ))}
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-3">Connect</h4>
              <div className="space-y-2">
                <a
                  href="mailto:oralyticsai@gmail.com"
                  className="block text-gray-300 hover:text-white transition-colors"
                >
                  Email
                </a>
                <a
                  href="#contact"
                  className="block text-gray-300 hover:text-white transition-colors"
                >
                  Join Waitlist
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-gray-400 text-sm">
            © 2025 Oralytics. Built by Ritvik Bansal.
          </div>
          <div className="flex space-x-6 text-sm text-gray-400">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 